// shared/components/admin/AddAuthorizationTemplate.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import { toast } from 'react-toastify';

import SecondaryButton from '../SecondaryButton';

const AddAuthorizationTemplate = () => {
    const navigate = useNavigate();

    const createAuthorizationTemplate = useStoreActions(
        (a) => a.middleware.AuthorizationMiddleware.createAuthorizationTemplate
    );

    const [title, setTitle] = useState('');
    const [category, setCategory] = useState('');
    const [version, setVersion] = useState(1);
    const [isActive, setIsActive] = useState(true);
    const [bodyText, setBodyText] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!title.trim()) {
            toast.error('❗️ Le titre est obligatoire');
            return;
        }
        if (!bodyText.trim()) {
            toast.error('❗️ Le texte est obligatoire');
            return;
        }

        try {
            await createAuthorizationTemplate({
                title: title.trim(),
                bodyText,
                category: category.trim() || null,
                version: Number(version) || 1,
                isActive,
            });
            toast.success('✅ Autorisation créée');
            navigate('/authorizations');
        } catch (err) {
            console.log('❌ createAuthorizationTemplate error', err);
            toast.error("❗️ Erreur lors de la création de l’autorisation");
        }
    };

    return (
        <section className="md:pt-14 px-4 md:px-9">
            <div className="flex flex-col space-y-4 items-center justify-between border-b border-gray-admin pb-4 pt-11 md:pt-0 mb-4 md:flex-row md:space-y-0">
                <h3 className="font-bold text-xl">Ajouter une autorisation</h3>
                <SecondaryButton title="← Retour" link={'/authorizations'} />
            </div>

            <form onSubmit={onSubmit} className="mt-6 max-w-3xl space-y-4">
                <div>
                    <label className="block text-sm font-semibold mb-1">Titre *</label>
                    <input
                        className="w-full border rounded-lg px-3 py-2"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Ex : Autorisation d’accès logement"
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div>
                        <label className="block text-sm font-semibold mb-1">Catégorie</label>
                        <input
                            className="w-full border rounded-lg px-3 py-2"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            placeholder="Ex : Intervention"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-semibold mb-1">Version</label>
                        <input
                            type="number"
                            className="w-full border rounded-lg px-3 py-2"
                            value={version}
                            onChange={(e) => setVersion(e.target.value)}
                            min={1}
                        />
                    </div>

                    <div className="flex items-center gap-2 mt-6">
                        <input
                            type="checkbox"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                        />
                        <span className="text-sm">Actif</span>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-semibold mb-1">Texte *</label>
                    <textarea
                        className="w-full border rounded-lg px-3 py-2 min-h-[220px]"
                        value={bodyText}
                        onChange={(e) => setBodyText(e.target.value)}
                        placeholder="Acceptez-vous que..."
                    />
                </div>

                <div className="pt-2">
                    <button
                        type="submit"
                        className="bg-blue-admin text-white font-semibold px-4 py-2 rounded-lg"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </section>
    );
};

export default AddAuthorizationTemplate;
